import bg1 from "../../assets/images/bg1.jpg";
import sabadKharid from "../../assets/images/Main Image.png";

export default function HeaderLanding2() {
  return (
    <div className="header-landing2">
      <div className="header-main position-relative">
        <div
          className="d-flex justify-content-around  align-item-center   header-main-child"
          // style={{
          //   height: "280px",
          //   position: "absolute",
          //   top: "-135px",
          //   width: "86%",
          //   left: "7%",
          // }}
        >
          <div className="w-50">
            <h1 className="title1" style={{ paddingRight: "100px" }}>
              سبدی
            </h1>
            <h1 className="title2 mt-2" style={{ paddingRight: "100px" }}>
              همراه یک خرید کامل!
            </h1>
          </div>
          <div
            className="header-image"
            style={{ paddingBottom: "100px", width: "50%" }}
          >
            <img src={sabadKharid} />
          </div>
        </div>
      </div>
    </div>
  );
}
